import { BloctoInjected } from './BloctoInjected.js';
export { BloctoInjected } from './BloctoInjected.js';
import { BraveEvm } from './BraveEvm.js';
export { BraveEvm } from './BraveEvm.js';
import { Dawn } from './Dawn.js';
export { Dawn } from './Dawn.js';
import { ExodusEvm } from './ExodusEvm.js';
export { ExodusEvm } from './ExodusEvm.js';
import { Frame } from './Frame.js';
export { Frame } from './Frame.js';
import { GameStop } from './GameStop.js';
export { GameStop } from './GameStop.js';
import { MetaMask } from './MetaMask.js';
export { MetaMask } from './MetaMask.js';
import { Opera } from './Opera.js';
export { Opera } from './Opera.js';
import { PhantomEvm } from './PhantomEvm.js';
export { PhantomEvm } from './PhantomEvm.js';
import { Trust } from './Trust.js';
export { Trust } from './Trust.js';
import { UnknownInjectedWallet } from './UnknownInjectedWallet.js';
export { UnknownInjectedWallet } from './UnknownInjectedWallet.js';
import { Zerion } from './Zerion.js';
export { Zerion } from './Zerion.js';
import { Superb } from './Superb.js';
import { Rabby } from './Rabby.js';
export { Rabby } from './Rabby.js';
import { OKX } from './OKX.js';
export { OKX } from './OKX.js';

const injectedWallets = [
    BloctoInjected,
    BraveEvm,
    Dawn,
    ExodusEvm,
    Frame,
    GameStop,
    MetaMask,
    Opera,
    PhantomEvm,
    Trust,
    UnknownInjectedWallet,
    Zerion,
    Superb,
    Rabby,
    OKX,
];

export { injectedWallets };
